export default {
  main: {
    titulo: { label: "Auditoría" }
    , subtitulo: { label: "Lista de Cambios" }
    , descripcion: { label: "Descripción" }
    , revision: { th: "Revisión" }
    , usuario: { th: "Usuario" }
    , fecha: { th: "Fecha" }
    , hora: { th: "Hora" }
    , detail: "Ver Detalle"
  }
  , detail: {
    subtitulo: { label: "Detalle de cambios" }
    , campos: { th: "Campos" }
    , anterior: { th: "Anterior" }
    , seleccionada: { th: "Actual" }
  }
  , errors: {
    BD1002: { text: "Ocurrió un error al obtener los registros de auditoría" }
    , WS1002: { text: "Ocurrió un error al obtener los registros de auditoría" }
    , JS1002: { text: "Ocurrió un error al obtener los registros de auditoría" }
    , CR1002: { text: "Ocurrió un error al obtener los registros de auditoría" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/auditoria.js